import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
} from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";

// Importo componenti
import StepWizard from "./componets/StepWizard";
import DragAndDrop from "./upload_wizard/DragAndDrop";
import Summary from "./upload_wizard/Summary";
import FinalRescue from "./upload_wizard/FinalRescue";

//Importo Menu
import { MenuDesktop } from "./componets/Menu_desktop";
import { MenuMobile } from "./componets/Menu_mobile";
import { MenuNavigazioneMobile } from "./componets/Menu_navigazioneMobile";
import { MenuNavigazioneDesktop } from "./componets/Menu_navigazioneDesktop";

function Upload() {
    const navigate = useNavigate();

    //Dichiaro gli State
    const [patient_images, setPatientImages] = useState([]);
    const [active_step, setActiveStep] = useState(0);

    const GetAnno = () => {
        return new Date().getFullYear();
    };

    useEffect(() => {
        if (active_step === 0) {
            setPatientImages([])
        }
    }, [active_step])

    return (
        <>
            <div className="flex flex-col min-h-screen bg-gray-100">
                <Disclosure as="nav" className="bg-white shadow-sm">
                    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                        <div className="flex h-16 justify-between">
                            <div className="flex">
                                <div className="flex flex-shrink-0 items-center">
                                    <img
                                        alt="Your Company"
                                        src="https://fileserver.centrodelsorriso.tribusinformatica.it/logo_top.png"
                                        className="block h-8 w-auto lg:hidden"
                                    />
                                    <img
                                        alt="Your Company"
                                        src="https://fileserver.centrodelsorriso.tribusinformatica.it/logo_top.png"
                                        className="hidden h-8 w-auto lg:block"
                                    />
                                </div>
                                <MenuNavigazioneDesktop
                                    navigate={navigate}
                                />
                            </div>

                            <div className="hidden xl:flex sm:ml-6 sm:items-center">
                                {/* Profile dropdown */}
                                <MenuDesktop />
                            </div>

                            {/* Mobile Section */}
                            <div className="-mr-2 flex items-center xl:hidden">
                                {/* Mobile menu button */}
                                <DisclosureButton className="group relative inline-flex items-center justify-center rounded-md bg-white p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                                    <span className="absolute -inset-0.5" />
                                    <span className="sr-only">
                                        Open main menu
                                    </span>
                                    <Bars3Icon
                                        aria-hidden="true"
                                        className="block h-6 w-6 group-data-[open]:hidden"
                                    />
                                    <XMarkIcon
                                        aria-hidden="true"
                                        className="hidden h-6 w-6 group-data-[open]:block"
                                    />
                                </DisclosureButton>
                            </div>
                        </div>
                    </div>

                    {/* Mobile  */}
                    <DisclosurePanel className="xl:hidden">
                        <MenuNavigazioneMobile
                            navigate={navigate}
                        />
                        <MenuMobile />
                    </DisclosurePanel>
                </Disclosure>

                <div className="flex-grow py-10">
                    <header>
                        <div className="mx-auto max-w-7xl flex justify-center xl:justify-start">
                            <h1 className="text-3xl font-bold leading-tight tracking-tight text-gray-900">
                                Upload
                            </h1>
                        </div>
                    </header>
                    <main>
                        <div className="mx-auto max-w-7xl py-8">
                            <StepWizard
                                steps={[
                                    "Caricamento immagini",
                                    "Riepilogo immagini",
                                    "Valutazione finale"
                                ]}
                                active_step={active_step}
                            />
                        </div>
                        {
                            active_step === 0 ?
                                <DragAndDrop
                                    patient_images={patient_images}
                                    setPatientImages={setPatientImages}
                                    setActiveStep={setActiveStep}
                                /> :
                                active_step === 1 ?
                                    <Summary
                                        patient_images={patient_images}
                                        setPatientImages={setPatientImages}
                                        setActiveStep={setActiveStep}
                                    /> : active_step === 2 ?
                                        <FinalRescue
                                            patient_images={patient_images}
                                            setPatientImages={setPatientImages}
                                            setActiveStep={setActiveStep}
                                        /> :
                                        null
                        }
                    </main>
                </div>

                <footer className="bg-white">
                    <div className="mx-auto px-6 sm:py-3 md:py-3 xl:py-5 items-center">
                        <div className="mt-4 md:order-1 md:mt-0">
                            <p className="text-center text-xs leading-5 text-gray-500">
                                {GetAnno()} © Centro del Sorriso, sviluppato
                                con il ❤️ da Tribus Informatica Srl
                            </p>
                        </div>
                    </div>
                </footer>
            </div>
        </>
    );
}

export default Upload;
